<form [formGroup]="form">
  @if (displayCaptcha) {
    <div class="d-flex justify-content-center my-3 captcha-container">
      <ngx-turnstile
        [siteKey]="recaptchaKey"
        [theme]="recaptchaTheme"
        [tabIndex]="0"
        (resolved)="updateCaptcha($event)"
        (errored)="captchaError($event)"
        (data-expired-callback)="captchaError($event)"
      ></ngx-turnstile>
    </div>
  }
  @if (!displayCaptcha) {
    <div class="captcha-failed-container">
      <div class="w-100">
        <div class="d-flex justify-content-center w-100">
          Captcha has timed-out.
        </div>
        <div class="d-flex justify-content-center w-100">
          Click <span class="reload-captcha" (click)="restartCaptcha()">here</span> to reload the page.
        </div>
      </div>
    </div>
  }
</form>